import { render, staticRenderFns } from "./fileMaterialDia.vue?vue&type=template&id=da635b2a&scoped=true"
import script from "./fileMaterialDia.vue?vue&type=script&lang=js"
export * from "./fileMaterialDia.vue?vue&type=script&lang=js"
import style0 from "./fileMaterialDia.vue?vue&type=style&index=0&id=da635b2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da635b2a",
  null
  
)

export default component.exports